var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useFormikContext } from "formik";
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import React, { useState } from "react";
import { usePreview } from "../../generator-api";
import { errorMessage } from "../../generator-error-messages";
import { getPrograms } from "../../generator-utils";
var getFormatType = function (values) {
    var program = values.program, format = values.format;
    var selectedProgram = getPrograms().find(function (_a) {
        var value = _a.value;
        return value === program;
    });
    var selectedFormatGroup = selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.formatGroups.find(function (_a) {
        var formats = _a.formats;
        return formats.find(function (_a) {
            var formatTypes = _a.formatTypes;
            return formatTypes.find(function (_a) {
                var value = _a.value;
                return value === format;
            });
        });
    });
    var selectedFormat = selectedFormatGroup === null || selectedFormatGroup === void 0 ? void 0 : selectedFormatGroup.formats.find(function (_a) {
        var formatTypes = _a.formatTypes;
        return formatTypes.find(function (_a) {
            var value = _a.value;
            return value === format;
        });
    });
    var selectedFormatType = selectedFormat === null || selectedFormat === void 0 ? void 0 : selectedFormat.formatTypes.find(function (_a) {
        var value = _a.value;
        return value === format;
    });
    var formatType = selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.value;
    return { formatType: formatType };
};
export var PdfViewer = function (_a) {
    var _b;
    var setToken = _a.setToken, token = _a.token;
    var initialWidth = 300;
    var values = useFormikContext().values;
    var formatType = getFormatType(values).formatType;
    var _c = __read(useState(null), 2), numPages = _c[0], setNumPages = _c[1];
    var _d = usePreview(values, token, true), loading = _d.loading, url = _d.url, message = _d.message;
    // if (message == 'RECAPTCHA_VERIFICATION_FAILED'){
    //   setToken(null);
    // }
    var _e = __read(useState(initialWidth), 2), width = _e[0], setWidth = _e[1];
    var _f = __read(useState(initialWidth / 4), 2), zoomStep = _f[0], setZoomStep = _f[1];
    var viewerContainerWidth = (_b = document.querySelector('.preview-pdf__viewer_container')) === null || _b === void 0 ? void 0 : _b.clientWidth;
    if (width == initialWidth && viewerContainerWidth != undefined) {
        setWidth(viewerContainerWidth - 2);
        setZoomStep(viewerContainerWidth / 4);
    }
    function onDocumentLoadSuccess(_a) {
        var numPages = _a.numPages;
        setNumPages(numPages);
    }
    function zoomIn() {
        setWidth(width + zoomStep);
    }
    function zoomOut() {
        setWidth(width - zoomStep);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "preview-pdf__viewer_container" }, loading ? (React.createElement("div", { className: "preview-pdf__loading-screen" },
            React.createElement("svg", { className: "loader__loader", viewBox: "0 0 120 120", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("circle", { className: "loader__circle", cx: "60", cy: "60", r: "40" }),
                React.createElement("g", null,
                    React.createElement("circle", { className: "loader__dot loader__dot--first", cx: "45", cy: "70", r: "4" }),
                    React.createElement("circle", { className: "loader__dot loader__dot--second", cx: "60", cy: "70", r: "4" }),
                    React.createElement("circle", { className: "loader__dot loader__dot--third", cx: "75", cy: "70", r: "4" }))),
            formatType === "poster_electronic_single" ? "Probíhá načítání jpg" : "Probíhá načítání pdf")) : (message == undefined ? (formatType === "poster_electronic_single" ? (React.createElement("img", { className: "preview-pdf__img_viewer", src: "data:image/jpeg;base64," + url })) : (React.createElement(Document, { file: "data:application/pdf;base64," + url, onLoadSuccess: onDocumentLoadSuccess },
            React.createElement(Page, { pageNumber: 1, width: width })))) : (React.createElement("div", { className: "preview-pdf__loading-screen" }, errorMessage(message))))),
        !loading && message == undefined ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "preview-pdf__buttons" },
                React.createElement("button", { type: 'button', className: 'preview-pdf__button_zoom', onClick: zoomIn }, "+"),
                React.createElement("button", { type: 'button', className: 'preview-pdf__button_zoom', onClick: zoomOut }, "-")))) : (React.createElement(React.Fragment, null))));
};
